<i18n src='@/locale/header-localization.json'></i18n>

<template>
    <nav class="navbar">
        <sign-in-dialog/>
        <v-navigation-drawer v-if="$store.state.IsAuthenticated && !readOnly" v-model="sideNav" app temporary>
            <v-list>
                <v-list-group
                    v-for="(navObj, i) in $store.state.navigation"
                    :key="i"
                    no-action
                >
                    <template v-slot:activator>
                        <v-list-item>
                            <v-list-item-title>{{
                                    $t(navObj.key)
                                }}
                            </v-list-item-title>
                        </v-list-item>
                    </template>
                    <v-list-item
                        v-for="(navItem, ind) in navObj.items"
                        :key="ind"
                        dense
                    >
                        <a
                            :href="navItem.url"
                            class="grey--text text--darken-3"
                            :rel="
                                navItem.new_window ? 'noopener noreferrer' : ''
                            "
                            :target="navItem.new_window ? '_blank' : ''"
                        >
                            <v-list-item-title>
                                {{ navItem.name || $t(navItem.key) }}
                            </v-list-item-title>
                        </a>
                    </v-list-item>
                </v-list-group>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar elevate-on-scroll short dark app color="grey darken-4">
            <v-app-bar-nav-icon
                @click="sideNav = true"
                class="white--text"
                v-if="$store.state.IsAuthenticated && $vuetify.breakpoint.smAndDown && !readOnly"
            ></v-app-bar-nav-icon>

            <v-btn
                plain
                color="grey lighten-5"
                class="
                    text-capitalize
                    text-xl-h5
                    text-lg-h6
                    text-md-subtitle-1
                    text-sm-subtitle-2
                "
            >
                Webmed Core
            </v-btn>

            <template v-if="$store.state.IsAuthenticated && $vuetify.breakpoint.mdAndUp && !readOnly">
                <v-menu
                    v-for="(navObj, i) in $store.state.navigation"
                    :key="i"
                    offset-y
                >
                    <template v-slot:activator="{ on }">
                        <v-btn
                            plain
                            v-on="on"
                            color="grey lighten-3"
                            class="px-2"
                        >
                            <span>{{ $t(navObj.key) }}</span>
                        </v-btn>
                    </template>
                    <v-list dark max-height="70vh" color="grey darken-4">
                        <v-list-item
                            v-for="(navItem, ind) in navObj.items"
                            :key="ind"
                            dense
                            class="px-0"
                        >
                            <v-list-item-title>
                                <a
                                    :href="navItem.url"
                                    :rel="
                                        navItem.new_window
                                            ? 'noopener noreferrer'
                                            : ''
                                    "
                                    :target="navItem.new_window ? '_blank' : ''"
                                >
                                    <v-btn block plain class="justify-start">{{
                                            navItem.name || $t(navItem.key)
                                        }}
                                    </v-btn>
                                </a>
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>

            <v-spacer></v-spacer>
            <notification-popup v-if="$store.state.IsAuthenticated && $store.state.notificationUrl"/>
            <v-tooltip v-model="userInfoVis" bottom v-if="$store.state.IsAuthenticated && !readOnly">
                <template v-slot:activator="{}">
                    <v-btn
                        @click="GetUserInfo"
                        :loading="userInfoLoading"
                        :disabled="userInfoLoading"
                        color="primary"
                        small
                        dark
                        fab
                    >
                        <v-icon>bar_chart</v-icon>
                    </v-btn>
                </template>
                <v-list dark color="rgba(0, 0, 0, 0)">
                    <v-list-item
                        v-for="(val, key) in userPaymentData"
                        :key="key"
                    >
                        <v-list-item-content>
                            <v-list-item-title>{{ key }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>{{ val }}</v-list-item-action>
                    </v-list-item>
                </v-list>
            </v-tooltip>

            <v-menu :close-on-content-click="false" offset-y v-if="$store.state.IsAuthenticated" :disabled="readOnly">
                <template v-slot:activator="{ on }">
                    <template>
                        <v-btn
                            v-if="$vuetify.breakpoint.mdAndUp"
                            class="text-capitalize mx-3"
                            :class="{'cursor-default': readOnly}"
                            elevation="4"
                            color="primary"
                            v-on="on"
                        >
                            <v-tooltip bottom v-if="$store.state.MustChangePasswordDate">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        color="yellow darken-2"
                                        dark
                                        v-bind="attrs"
                                        v-on="on"
                                        style="padding-right: 5px;"
                                    >
                                        mdi-alert
                                    </v-icon>
                                </template>
                                <span>{{ mustChangePasswordText }}</span>
                            </v-tooltip>
                            <span
                                :title="getUserGroupNames()"
                            >{{ $store.state.FullName }} {{ $store.state.PersonCode }}</span>
                        </v-btn>
                        <v-btn
                            v-else
                            color="primary"
                            small
                            depressed
                            fab
                            class="mx-1"
                            v-on="on"
                        >
                            <span v-if="$store.state.FullName">
                                {{
                                    $store.state.FullName.split(' ')
                                        .map((n) => n[0])
                                        .join('.')
                                }}
                            </span>
                            <v-icon v-else>account_circle</v-icon>
                        </v-btn>
                    </template>
                </template>
                <v-list dark>
                    <v-list-item>

                        <v-select
                            v-model="activeLang"
                            :items="langs"
                            item-value="value"
                            style="max-width: 152px"
                            :menu-props="{dark: true}"
                            @change="langChanged">

                            <template v-slot:selection="{ item }">
                                <v-img :src="langImage(item.value)" max-width="20px" class="mr-1"></v-img>
                                {{ item.text }}
                            </template>

                            <template v-slot:item="{item}">
                                <v-img :src="langImage(item.value)" max-width="20px" class="mr-1"></v-img>
                                {{ item.text }}
                            </template>

                        </v-select>

                    </v-list-item>

                    <v-list-item>
                        <v-btn
                            plain
                            :ripple="false"
                            @click="passwordDialogVis = true"
                            class="pa-0"
                        >
                            <v-icon left>
                                password
                            </v-icon>
                            პაროლის შეცვლა
                        </v-btn>
                    </v-list-item>
                    <v-list-item>
                        <span @click="logOut">
                            <v-btn text color="disabled">
                                <!-- old version ->  v-if="$vuetify.breakpoint.lgAndUp"  -->
                                <v-icon :left="$vuetify.breakpoint.lgAndUp">exit_to_app</v-icon>
                                <span>
                                    {{ $t('Text_LogOff') }}
                                </span>
                            </v-btn>
                        </span>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
        <v-wm-password-change-dialog
            v-if="passwordDialogVis"
            @cancel='passwordDialogVis = false'
            @save='passwordDialogVis = false'
        ></v-wm-password-change-dialog>
    </nav>
</template>

<script>
import VWmPasswordChangeDialog from '@/component/password-change-dialog.vue';
import userInfoService from '@/script/user-info-service';
import {getDateStr, nullableToFixed} from '@/script/common';
import myi18 from "@/plugin/i18n";
import signInService from "@/service/signIn-service";
import signInDialog from "@/component/signIn/signInDialog";
import NotificationPopup from "@/component/notification/notification-popup";

export default {
    name: 'VWmHeader',
    components: {
        NotificationPopup,
        VWmPasswordChangeDialog,
        signInDialog
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            sideNav: false,

            userInfoLoading: false,
            userInfoVis: false,
            userPaymentData: {},

            passwordDialogVis: false,

            langs: [
                {
                    value: 'en',
                    text: 'English'
                },
                {
                    value: 'ka',
                    text: 'ქართული'
                }
            ],
            activeLang: 'ka'
        };
    },

    computed: {
        userId() {
            return this.$store.state.PersonCode;
        },
        mustChangePasswordText() {
            let mustChangePasswordDate = this.$store.state.MustChangePasswordDate;
            return this.$t('MustChangePasswordText').replace('{date}', getDateStr(mustChangePasswordDate));
        }
    },

    mounted() {
        this.setLastOpenedPage();
    },

    methods: {
        async GetUserInfo() {
            if (!this.userInfoVis) {
                this.userInfoLoading = true;
                await userInfoService.getUserInfo().then((payData) => {
                    for (const key in payData.Pay) {
                        if (payData.Pay.hasOwnProperty.call(payData.Pay, key)) {
                            this.$set(
                                this.userPaymentData,
                                key,
                                `
                                ${nullableToFixed(
                                    nullableToFixed(payData.Pay[key], 2) -
                                    nullableToFixed(payData.Return[key], 2),
                                    2
                                )}
                                =
                                ${nullableToFixed(payData.Pay[key], 2)}
                                -
                                ${nullableToFixed(payData.Return[key], 2)}
                            `
                                    .replace(/\s+/g, ' ')
                                    .trim()
                            );
                        }
                    }
                });
            }
            this.userInfoLoading = false;
            this.userInfoVis = !this.userInfoVis;
        },
        langChanged(lang) {
            this.activeLang = myi18.locale = lang;
            this.changeLang(this.activeLang, this.userId);
        },
        changeLang(lang, userId) {
            if (!lang) { // when page load
                if (localStorage.users) { // if users is in localStorage
                    let users = JSON.parse(localStorage.users);
                    if (users[userId] && users[userId].lang) // if user's has language
                        this.activeLang = myi18.locale = users[userId].lang;
                }
            } else { // when lang changed
                let users = localStorage.users ? JSON.parse(localStorage.users) : {};
                if (!users[userId]) users[userId] = {};
                users[userId]["lang"] = lang;
                localStorage.users = JSON.stringify(users);
            }
        },
        langImage(lang) {
            return require(`@/asset/icons/${lang}.svg`);
        },
        setLastOpenedPage() {
            if (this.readOnly) {
                return;
            }
            const pageLink = window.location.pathname;

            // check if need save and if exists user id
            if (pageLink && pageLink !== "/" && pageLink !== "/signIn" && pageLink !== "/signIn.html" && this.userId) {
                let users = localStorage.users ? JSON.parse(localStorage.users) : {};
                if (!users[this.userId]) {
                    users[this.userId] = {};
                }
                users[this.userId]["lastOpenedUrl"] = pageLink;
                localStorage.users = JSON.stringify(users);
            }
        },
        redirectToLastOpenedPage() {
            const pageLink = window.location.pathname;

            if ((!pageLink || pageLink === "/") && this.$store.state.IsAuthenticated && this.userId && localStorage.users) {
                let users = JSON.parse(localStorage.users);
                let lastOpenedUrl = null;
                if (users[this.userId] && users[this.userId]["lastOpenedUrl"]) {
                    lastOpenedUrl = users[this.userId]["lastOpenedUrl"];
                }
                if (lastOpenedUrl && lastOpenedUrl !== "/signIn" && lastOpenedUrl !== "/signIn.html") {
                    location.assign(lastOpenedUrl);
                }
            }
        },
        logOut() {
            signInService.signOut().then((res) => {
                if (res.ok) {
                    this.$store.commit("RemoveGlobalData");
                    location.assign("/signIn");
                }
            });
        },
        getUserGroupNames() {
            let names = this.$store.state.userGroups.map(ug => ug.groupName).join(", ");
            if (names) {
                return `ჯგუფები: ${names}`;
            }
            return null;
        }
    },
    watch: {
        userId(val) {
            this.changeLang(null, val);
            this.setLastOpenedPage();
            this.redirectToLastOpenedPage();
        }
    }
};
</script>

<style scoped lang="scss">
a {
    text-decoration: none;
}

.pointer {
    cursor: pointer;
}

@keyframes blinker {
    10%,
    90% {
        opacity: 1;
    }
    50% {
        opacity: 0;
    }
}

::v-deep {
    .v-list {
        overflow-y: auto;

        &::-webkit-scrollbar-track {
            box-shadow: inset 0 0 0.3rem rgba(0, 0, 0, 0.3);
            background-color: #212121;
        }

        &::-webkit-scrollbar {
            width: 0.75rem;
            background-color: #212121;
        }

        &::-webkit-scrollbar-thumb {
            box-shadow: inset 0 0 0.3rem rgba(0, 0, 0, 0.3);
            background-color: #555;
        }
    }

    .v-icon.in-progress-dot {
        color: #76ff03 !important;
        text-shadow: 0 0 4px #76ff03 !important;
        animation: blinker 1s linear infinite;
    }
}

.cursor-default {
    cursor: default;
}
</style>
